import Api from './api';

class Search {


    generateUrlParameter(value,type){

        if(value)
            return `&${type}=${value}`;
        else
            return '';
    }

    async searchDataSets(value) {

        try {

            let title = this.generateUrlParameter(value.query,'title');
            let frequency = this.generateUrlParameter(value.frequency,'frequency');
            let source = this.generateUrlParameter(value.source,'source');
            let tags = this.generateUrlParameter(value.tags,'tags');
            let category = this.generateUrlParameter(value.category,'category');
            let items_per_page = this.generateUrlParameter(20,'items_per_page');
            let page = this.generateUrlParameter(value.page-1,'page');

            let url;

            if(!value.query && !value.frequency && !value.category && !value.source && !value.tags && !value.page )
               url = 'api/datasets?items_per_page=20&page=0&_format=json';
            else
                url = `api/datasets?${title}${frequency}${source}${tags}${category}${items_per_page}${page}&_format=json`;


            let res = await Api.get(url);

            return res.body;
        }
        catch (error) {
            console.log(error);

            return [];
        }
    }

    async searchTotalCount(value) {
        try {
            
            let url = 'api/datasets/count?_format=json&items_per_page=All&title=' ;
            url =  (value.query && value.query !== '') ? url + '&title=' + value.query : url;
            url = (value.frequency && value.frequency !== '') ? url + '&frequency=' + value.frequency : url;
            url = (value.category && value.category !== '') ? url + '&category=' + value.category : url;
            url = (value.source && value.source !== '') ? url + '&source=' + value.source : url;
            url = (value.tags && value.tags !== '') ? url + '&tags=' + value.tags : url;
            
            if (value.title === '' && value.frequency === '') {
                url = 'api/datasets/count?_format=json';
            }

            let res = await Api.get(url);

            return res.body;
        }
        catch (error) {
            console.log(error);

            return [];
        }
    }

    async searchData(query) {
        // let formatQuery = query.replace('?', '&');
        if(query.indexOf('?') === -1) query = `?${query}`;
        let url = `api/search${query ? query : '?'}&items_per_page=All`;
    
        const res = await Api.get(url);
        return res.body;
        
        // console.log(uri)
    }

    async searchByKeyword(keyword) {
      const url = `api/datasets/compare-search?title=${keyword}`
      const res = await Api.get(url);
      return res.body;
    }
}

export default new Search();



// WEBPACK FOOTER //
// ./src/app/services/searchService.js